(function () {
  'use strict';

  if (window.__epdmSnijstukHandlerInitialized) return;

  const cfg = window.__epdmSnijstukConfig;
  if (!cfg) return;

  const PRODUCT_HANDLE = cfg.handle;
  const CURRENT_PRODUCT_ID = cfg.productId;

  const originalFetch = window.fetch.bind(window);

  // ============================================
  // CONFIGURATIE
  // Formaat: 'epdm_variant_id': { snijstukId, breedte }
  // ============================================

  const PRODUCT_MAPPINGS = {
    // EPDM 1.14mm Zwart
    '6989954547757': {
      name: 'EPDM 1.14mm Zwart',
      variantToSnijstuk: {
        '41252656775213': { snijstukId: '48525735985494', breedte: '1.00 m' },
        '40816691839021': { snijstukId: '48525736018262', breedte: '1.52 m' },
        '40507979268141': { snijstukId: '48363956207958', breedte: '2.44 m' },
        '48718734229846': { snijstukId: '48717123060054', breedte: '2.75 m' },
        '40507979300909': { snijstukId: '48363956240726', breedte: '3.05 m' },
        '55453086220630': { snijstukId: '55328237781334', breedte: '3.35 m' },
        '40507979333677': { snijstukId: '48363956273494', breedte: '3.66 m' },
        '46483567378774': { snijstukId: '48363956306262', breedte: '3.96 m' },
        '40507979366445': { snijstukId: '48363956339030', breedte: '4.58 m' },
        '44363884036375': { snijstukId: '48363956371798', breedte: '5.08 m' },
        '40507979431981': { snijstukId: '48363956404566', breedte: '6.10 m' },
        '47059385319766': { snijstukId: '48363956437334', breedte: '7.62 m' },
        '47059385352534': { snijstukId: '48363956470102', breedte: '9.15 m' },
        '47059385385302': { snijstukId: '48363956502870', breedte: '12.20 m' },
      },
    },

    // EPDM 1.52mm Zwart
    '10034085855574': {
      name: 'EPDM 1.52mm Zwart',
      variantToSnijstuk: {
        '52084645462358': { snijstukId: '52084584743254', breedte: '3.05 m' },
        '54551804576086': { snijstukId: '54551745757526', breedte: '3.66 m' },
        '52084645560662': { snijstukId: '52084584874326', breedte: '4.58 m' },
        '52087033856342': { snijstukId: '52087000072534', breedte: '5.08 m' },
        '52084645626198': { snijstukId: '52084584939862', breedte: '6.10 m' },
        '52087033889110': { snijstukId: '52087000105302', breedte: '7.62 m' },
        '52087033921878': { snijstukId: '52087000138070', breedte: '9.15 m' },
        '52087033954646': { snijstukId: '52086980247894', breedte: '12.20 m' },
      },
    },

    // EPDM 1.52mm Wit
    '7218037719085': {
      name: 'EPDM 1.52mm Wit',
      variantToSnijstuk: {
        '52962219589974': { snijstukId: '50049043923286', breedte: '1.00 m' },
        '52962219622742': { snijstukId: '50049043956054', breedte: '1.52 m' },
        '52962219655510': { snijstukId: '50060192940374', breedte: '2.00 m' },
        '52962219688278': { snijstukId: '50049043988822', breedte: '3.05 m' },
        '52962219721046': { snijstukId: '50049044021590', breedte: '6.10 m' },
      },
    },
  };

  const CONFIG = {
    lengteProperty: '__lengte_x',
    quantityMultiplier: 10,
    minimumQuantity: 1,
    debug: false,
  };

  // ============================================
  // HELPER FUNCTIES
  // ============================================

  function log(...args) {
    if (CONFIG.debug) console.log('[EPDM Snijstuk]', ...args);
  }

  function calculateQuantity(value) {
    if (!value) return CONFIG.minimumQuantity;
    const meters = parseFloat(String(value).replace(',', '.'));
    if (isNaN(meters)) return CONFIG.minimumQuantity;
    const converted = meters * CONFIG.quantityMultiplier;
    return Math.max(Math.ceil(converted), CONFIG.minimumQuantity);
  }

  function getCartEntry(data) {
    const variantId = String(data.id || '');
    const mapping = PRODUCT_MAPPINGS[CURRENT_PRODUCT_ID];
    if (!mapping) return null;

    const entry = mapping.variantToSnijstuk[variantId];
    if (!entry) return null;

    return {
      snijstukId: entry.snijstukId,
      breedte: entry.breedte,
      name: mapping.name,
    };
  }

  function processEpdmCartAdd(data) {
    const entry = getCartEntry(data);
    if (!entry) return null;

    const lengteRaw = (data.properties || {})[CONFIG.lengteProperty];
    const quantity = calculateQuantity(lengteRaw);

    log('Detected:', { product: entry.name, breedte: entry.breedte, lengteRaw, quantity });
    log('Swapping to snijstuk:', entry.snijstukId);

    return {
      id: entry.snijstukId,
      quantity: quantity,
      properties: {
        Breedte: entry.breedte,
        Lengte: lengteRaw + ' m',
        _Configurator: entry.name,
        _handle: PRODUCT_HANDLE,
        '_snijstuk-id': Math.random().toString(36).slice(2, 10),
      },
    };
  }

  // ============================================
  // FETCH INTERCEPTOR
  // ============================================

  window.fetch = new Proxy(originalFetch, {
    apply(target, thisArg, args) {
      const [url, options] = args;
      const isCartAdd = url && typeof url === 'string' && /\/cart\/add(?:\.js)?(?:\?|$)/.test(url);

      if (isCartAdd && options?.body && typeof options.body === 'string') {
        try {
          const data = JSON.parse(options.body);
          const newCartItem = processEpdmCartAdd(data);
          if (newCartItem) {
            args[1] = { ...options, body: JSON.stringify(newCartItem) };
            log('Cart modified for', newCartItem.properties._Configurator);
          }
        } catch (e) {
          // laat request ongewijzigd door bij parse-fout
        }
      }
      return Reflect.apply(target, thisArg, args);
    },
  });

  window.__epdmSnijstukHandlerInitialized = true;
  log('Initialized with', Object.keys(PRODUCT_MAPPINGS).length, 'product mappings');
})();
